import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import {
  ElderProgressBarComponent,
  ElderQuantityPipe,
  Quantity,
  SubBar,
} from '@elderbyte/ngx-starter'
import { FacilityUtilisation } from '../../facility/facility-utilisation'
import { ProgressBarUtils } from '../ProgressBarUtils'
import { ProgressBarColors } from '../ProgressBarColors'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'

@Component({
  selector: 'app-utilisation-progress-bar',
  templateUrl: './utilisation-progress-bar.component.html',
  styleUrls: ['./utilisation-progress-bar.component.scss'],
  imports: [ElderProgressBarComponent, ElderTranslatePipe, ElderQuantityPipe],
})
export class UtilisationProgressBarComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  @Input()
  public facilityUtilisation: FacilityUtilisation

  @Input()
  public legendHorizontal = false

  @Input()
  public hideLegendDescription = false

  @Input()
  public barThickness = 16

  public readonly Colors = ProgressBarColors

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  calculateProgress(facUtil: FacilityUtilisation): SubBar[] {
    const completed = facUtil.totalUtilisation.completed.itemCount
    const progress = facUtil.totalUtilisation.progress.itemCount
    const readyForProduction = facUtil.totalUtilisation.readyForProduction.itemCount
    const onHold = facUtil.totalUtilisation.onHold.itemCount
    const total = facUtil.totalItems.itemCount

    return ProgressBarUtils.calculateBars(completed, progress, readyForProduction, onHold, total)
  }

  getCompletedWeight(facilityUtilisation: FacilityUtilisation) {
    return facilityUtilisation.totalUtilisation.completed.totalWeight
  }

  getInProgressWeight(facilityUtilisation: FacilityUtilisation): Quantity {
    return facilityUtilisation.totalUtilisation.progress.totalWeight
  }

  getReadyWeight(facilityUtilisation: FacilityUtilisation): Quantity {
    return facilityUtilisation.totalUtilisation.readyForProduction.totalWeight
  }

  getOnHoldWeight(facilityUtilisation: FacilityUtilisation) {
    return facilityUtilisation.totalUtilisation.onHold.totalWeight
  }
}
